export default __webpack_public_path__ + "static/media/fortmatic.2393c835.svg";